import { render, staticRenderFns } from "./Secondary.vue?vue&type=template&id=1322679a&scoped=true"
import script from "./Secondary.vue?vue&type=script&lang=js"
export * from "./Secondary.vue?vue&type=script&lang=js"
import style0 from "./Secondary.vue?vue&type=style&index=0&id=1322679a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1322679a",
  null
  
)

export default component.exports